import React, { useEffect, useState } from 'react'

import './App.css'
import { useNavigate } from 'react-router-dom';
import StanderdConstants from '../../../services/StanderdConstants';
import { AddIconButton } from '../../../ButtonsIconsInputs/IconButtons';
import AddModal from './AddModal';
import Heading from '../../reusableComp/Heading';
import { InputBox } from '../../../ButtonsIconsInputs/CustomInputs';
import DataTable from './DataTable';
import EditModal from './EditModal';
import DeleteConfirmation from './Deletecomfirmation';
import useUserId from '../../../services/useUserId';



function CompanyPeople() {
    const [Data, SetData] = useState([]);
    const [open, setopen] = useState(false);
    const [insertionStatus, setInsertionStatus] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [filteredData, setfilteredData] = useState([]);
    const [editOpen, setEditOpen] = useState(false);
    const [currentDatarow, setcurrentDatarow] = useState(null);
    const api_url = process.env.REACT_APP_API_URL
    const navigate = useNavigate()
    const UserId = useUserId()
    const [query, setQuery] = useState('');


    useEffect(() => {
        if (insertionStatus) {
            GetPeopleOfCompany()
            setInsertionStatus(false);
        }
    }, [insertionStatus, Data]);


    const handleopen = () => { setopen(true); }
    const handleclose = () => { setopen(false); }
    const handleEditOpen = (Data, index) => {
                setcurrentDatarow(Data); setEditOpen(true);

    }
    const handleEditClose = () => { setEditOpen(false); setcurrentDatarow(null); console.log("called") }

    const handleDelete = async (item) => {
        



        const res = await fetch(`${api_url}/users/RemoveCompanyFromUser/?UserId=${item.Id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        });

        if (res.ok) {
            setInsertionStatus(true);
        } else {
                    }
    };







    const AssessmentActions = [
        // {
        //     label: StanderdConstants.EDIT_LABEL,
        //     handler: handleEditOpen,
        //     tooltip: StanderdConstants.EDIT_LABEL,
        //     ButtonComponent: EditIconButton,
        // },
        {
            label: StanderdConstants.DELETE_LABEL,
            handler: handleDelete,
            tooltip: StanderdConstants.DELETE_LABEL,
            ButtonComponent: DeleteConfirmation,

        }

    ];
    async function checkIfUserBelongsToOrganization() {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/companies/IsUserBelongsToOrganisation/?Id=${UserId}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!res.ok) {
                // Handle non-200 status codes
                return false;
            }

            const result = await res.json();
            
            if (result && result.company) {
                                return result.CompanyId
            } else {
                return false;
            }

        } catch (error) {
            // Handle network or unexpected errors
            console.error('Error fetching organization data:', error);
            return false;
        }
    }



    const GetPeopleOfCompany = async () => {
        try {
            const CompanyId = await checkIfUserBelongsToOrganization()
            const result = await fetch(`${process.env.REACT_APP_API_URL}/users/GetPeopleOfCompany/?CompanyId=${CompanyId}`, {
                method: 'get',
                headers: { 'Content-Type': 'application/json' },
            });
            const response = await result.json();
            if (result.ok) {
                SetData(response.data)
                setfilteredData(response.data)
            }

        } catch (error) {
                    }
    };

    useEffect(() => {
        GetPeopleOfCompany();
    }, []);



    useEffect(() => {
                if (editStatus) {
            GetPeopleOfCompany()
            setEditStatus(false)
        }
    }, [editStatus]);



    const handleSearch = (e) => {
                        const searchQuery = e.target.value.toLowerCase();
        setQuery(searchQuery);
        if (!searchQuery) {
            setfilteredData(Data);
        } else {
                        const result = Data.filter(row =>
                Object.values(row) // Get all values from the object (row)
                    .some(value =>
                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase()) // Check if any value contains the search query
                    )
            );
                        setfilteredData(result);
        }
    }

    return (
        <div className="container mx-auto py-8 px-2">
            <Heading heading={"Add/Invite Users For Company"} />
            <div className="flex flex-row  justify-between space-x-2 my-2 ">
                <div className="flex items-center space-x-2">
                    <InputBox
                        inputId='searchChannel'
                        inputLabel="Search Users"
                        inputValueValue={query}
                        className="border p-2 rounded-lg"

                        type="text"
                    />

                </div>
                {<div>
                    <AddIconButton action={() => handleopen(true)} id={"CompanyPeople"} tooltip='Add new role' />
                    {open && <AddModal handleClose={handleclose} setStatus={setInsertionStatus} />}

                </div>}

            </div>
            <div>
                <div>
                    {/* <DataPreview initialData={filteredData} /> */}
                    <DataTable data={filteredData} actions={AssessmentActions} />
                </div>
            </div>





            {editOpen && (
                <EditModal
                    Data={currentDatarow}
                    handleClose={handleEditClose}
                    setStatus={setEditStatus} />

            )}
        </div>

    )

}

export default CompanyPeople